export const DEFAULT_LIBRARY = [
  {
    id: "sources",
    name: "Sources",
    icon: "📁",
    items: [],
    description: "Vos médias importés (vidéo, audio, images)"
  },
  {
    id: "intro-outro",
    name: "Intro / Outro",
    icon: "🎬",
    items: [
      { id: "io1", name: "Forward Intro", duration: "00:04", info: "WEBM", type: 'video', url: "https://medias.storystudio.cc/IntroOutro/Forward-Intro.webm", clipRole: 'intro' },
      { id: "io2", name: "Forward Outro", duration: "00:04", info: "WEBM", type: 'video', url: "https://medias.storystudio.cc/IntroOutro/Forward-Outro.webm", clipRole: 'outro' },
    ],
  },
  {
    id: "synthes",
    name: "Synthés",
    icon: "💬",
    items: [
      { id: "s1", name: "Synthé de base (Nom/Titre)", duration: null, info: "Clip vide" },
    ],
  },
  {
    id: "panels",
    name: "Panels",
    icon: "🖼️",
    items: [
      {
        id: "p1",
        name: "Panel LVMH",
        duration: 5,
        info: "Fond + Texte bleu",
        type: 'panel',
        syntheData: {
          backgroundColor: '#000000',
          clips: [
            {
              id: 'panel-bg-default',
              type: 'image',
              name: 'Background',
              url: 'https://medias.storystudio.cc/IntroOutro/BG.png',
              trackId: 'v1',
              start: 0,
              duration: 5,
              originalDuration: 5,
              trimStart: 0,
              volume: 1,
              opacity: 1,
              fadeInDuration: 0,
              fadeOutDuration: 0,
              transform: { x: 0, y: 0, scale: 1, rotation: 0 }
            },
            {
              id: 'panel-text-default',
              type: 'text',
              name: 'Title',
              text: 'VOTRE TEXTE ICI',
              trackId: 't1',
              start: 0,
              duration: 5,
              originalDuration: 5,
              trimStart: 0,
              volume: 1,
              opacity: 1,
              fadeInDuration: 0.5,
              fadeOutDuration: 0.5,
              style: {
                fontFamily: '"LVMH Regular", sans-serif',
                fontSize: 80,
                color: '#0066FF',
                textAlign: 'center',
                textBaseline: 'middle'
              },
              transform: { x: 0, y: 0, scale: 1, rotation: 0 }
            }
          ],
          tracks: [
            { id: 't1', label: 'Overlays', accepts: ['text', 'image', 'synthe', 'panel'], isMagnetic: false, isVisible: true, isMuted: true },
            { id: 's1', label: 'Split', accepts: ['video', 'image', 'text'], isMagnetic: false, isVisible: true, isMuted: false },
            { id: 'v1', label: '1', accepts: ['video', 'image', 'audio', 'text'], isMagnetic: false, isVisible: true, isMuted: false },
            { id: 'v2', label: '2', accepts: ['video', 'image', 'audio', 'text'], isMagnetic: false, isVisible: true, isMuted: false },
            { id: 'z1', label: 'Zoom', accepts: ['zoom'], isMagnetic: false, isVisible: true, isMuted: true },
          ]
        }
      }
    ],
  },
  {
    id: "audio",
    name: "Audio",
    icon: "🎵",
    items: [
      { id: "a1", name: "Ganymede by Yehezkel Raz", duration: "02:27", info: "MP3", type: 'audio', url: 'https://medias.storystudio.cc/IntroOutro/IntroOutro_Yehezkel-Raz-Ganymede.mp3' },
    ],
  },
];

export const EXPORT_FORMATS = [
  { id: 'webm', label: 'WebM', extension: 'webm', codec: 'VP9' },
];

export const COMPRESSION_LEVELS = [
  { id: 'instant', label: 'Instantané', description: 'Export quasi-instantané, qualité standard' },
  { id: 'low', label: 'Équilibré', description: 'Bon équilibre vitesse/qualité' },
  { id: 'balanced', label: 'Haute Qualité', description: 'Qualité supérieure, export plus lent' },
  { id: 'high', label: 'Très Haute Qualité', description: 'Qualité maximale, export très lent' },
];

// Genre de voix (Homme / Femme)
export const VOICE_GENDERS = [
  { id: "all", label: "Toutes" },
  { id: "male", label: "👨 Homme" },
  { id: "female", label: "👩 Femme" },
];

// Vitesse de lecture VoiceOver
export const VOICE_SPEEDS = [
  { id: "slow", label: "🐢 Lent", multiplier: 0.8, instruction: "Speak slowly and deliberately, with pauses between sentences." },
  { id: "normal", label: "⏱️ Normal", multiplier: 1.0, instruction: "" },
  { id: "fast", label: "🚀 Rapide", multiplier: 1.2, instruction: "Speak quickly but clearly, maintaining good articulation." },
];

// Mappage des "Styles" de la démo Synergy vers les voix Gemini
// gender: 'male' | 'female' pour le filtre
export const VOICE_PRESETS = [
  { id: "Puck", label: "Movie Trailer (Puck)", style: "Deep, resonant, and dramatic movie trailer voice", icon: "🎬", gender: "male" },
  { id: "Fenrir", label: "Radio DJ (Fenrir)", style: "Energetic, fast-paced, and enthusiastic radio DJ voice", icon: "🎙️", gender: "male" },
  { id: "Kore", label: "Beauty Influencer (Kore)", style: "Soft, bright, and welcoming beauty influencer voice", icon: "💄", gender: "female" },
  { id: "Charon", label: "Podcaster (Charon)", style: "Professional, conversational, and engaging podcaster voice", icon: "🎧", gender: "male" },
  { id: "Aoede", label: "ASMR Pro (Aoede)", style: "Whispering, gentle, and calming ASMR voice", icon: "🤫", gender: "female" },
  { id: "Zephyr", label: "Meditative (Zephyr)", style: "Slow, calm, and meditative voice", icon: "🧘", gender: "female" },
  { id: "Orus", label: "Narrator (Orus)", style: "Natural, clear and warm storytelling voice", icon: "📖", gender: "male" },
  { id: "Leda", label: "Presenter (Leda)", style: "Confident, articulate, professional presenter voice", icon: "📺", gender: "female" },
];

export const VOICE_OPTIONS = VOICE_PRESETS.map(v => v.label);

export const VOICE_LANGUAGES = [
  { code: "en", label: "Anglais (English)" },
  { code: "fr", label: "Français (French)" },
  { code: "es", label: "Espagnol (Spanish)" },
  { code: "de", label: "Allemand (German)" },
  { code: "it", label: "Italien (Italian)" },
  { code: "ja", label: "Japonais (Japanese)" },
  { code: "ko", label: "Coréen (Korean)" },
  { code: "zh", label: "Chinois (Chinese)" },
];

export const VOICE_TONES = [
  { id: "default", label: "Par défaut (selon la voix)" },
  { id: "happy", label: "Joyeux / Enthousiaste" },
  { id: "sad", label: "Triste / Sérieux" },
  { id: "dramatic", label: "Dramatique" },
  { id: "whisper", label: "Chuchotement (ASMR)" },
  { id: "formal", label: "Formel / Journaliste" },
  { id: "fast", label: "Rapide / Énergique" },
  { id: "slow", label: "Lent / Calme" },
];

export const VOICE_PREVIEW_URLS: { [key: string]: string } = {
  "Movie Trailer (Puck)": "https://storage.googleapis.com/generative-ai-downloads/voices/Puck.wav",
  "Radio DJ (Fenrir)": "https://storage.googleapis.com/generative-ai-downloads/voices/Fenrir.wav",
  "Beauty Influencer (Kore)": "https://storage.googleapis.com/generative-ai-downloads/voices/Kore.wav",
  "Podcaster (Charon)": "https://storage.googleapis.com/generative-ai-downloads/voices/Charon.wav",
  "ASMR Pro (Aoede)": "https://storage.googleapis.com/generative-ai-downloads/voices/Aoede.wav",
};

export interface GeneratedVoice {
  id: string;
  text: string;
  voice: string;
  url: string;
  isLoading: boolean;
  duration?: number;
}